import * as React from 'react';
import { Svg } from '../svg';

function SvgEmailVerified({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path fill="url(#email-verified_svg__pattern0)" d="M0 0h80v80H0z" />
      <defs>
        <pattern
          id="email-verified_svg__pattern0"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#email-verified_svg__image0"
            transform="scale(.0125)"
          />
        </pattern>
        <image
          id="email-verified_svg__image0"
          width={80}
          height={80}
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgEmailVerified);
export default ForwardRef;
